import React from 'react';
import { GoogleOAuthProvider as GoogleProvider } from '@react-oauth/google';
import { getGoogleClientId } from '@/utils/common/environment';

interface GoogleOAuthProviderProps {
  children: React.ReactNode;
  isAdmin?: boolean;
}

/**
 * Google OAuth Provider for web platform
 * Matches the setup from the original web apps
 * 
 * @param isAdmin - Whether this is for admin login (affects which Google Client ID is used)
 */
export const GoogleOAuthProvider: React.FC<GoogleOAuthProviderProps> = ({ children, isAdmin = false }) => {
  const clientId = getGoogleClientId(isAdmin);

  return (
    <GoogleProvider clientId={clientId}>
      {children}
    </GoogleProvider>
  );
};
